export default __webpack_public_path__ + "static/quarter1-d73e5e8741e2b9719d97262f3c7013bc.png";